import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {AbstractHttp} from '../../core/classes/abstract-http';

@Injectable()
export class GetCurrentVersionService extends AbstractHttp {

  constructor(http: HttpClient) {
      const url = `${environment.ENTORNO}${environment.SessionService.URL}${environment.SessionService.ENDPOINT.GetCurrentVersion}`;
      super(http, url);
  }

}
